import {
  Card,
  CardContent,
  FormControl,
  TextField,
  Autocomplete,
} from "@mui/material";
import CustomizedSteppers from "./Stepper";
import { useEffect, useState } from "react";
import {
  getBatchStatus,
  getBatchStatusClear,
  getProjectsAndBatches,
} from "../../../redux/investigation/actions";
import { useDispatch, useSelector } from "react-redux";
import Label from "../../../components/Label/Label";

const BatchStatusCard = () => {
  const dispatch = useDispatch();
  const projectAndBatches = useSelector(
    (state) => state?.investigation?.projectAndBatches
  );
  const batchStatusAndName = useSelector(
    (state) => state?.investigation?.batchStatus
  );

  const [statusLoading, setStatusLoading] = useState(false);
  const [batchName, setBatchName] = useState("");
  const [projectData, setProjectData] = useState({
    name: "",
    index: null,
  });

  useEffect(() => {
    dispatch(getProjectsAndBatches());
    dispatch(getBatchStatusClear());
  }, []);

  useEffect(() => {
    setStatusLoading(false);
  }, [batchStatusAndName]);

  const handleChangeProjectName = (_, newValue) => {
    if (newValue) {
      const index = projectAndBatches.findIndex(
        (project) => project.drug_product === newValue
      );
      setProjectData({
        name: newValue,
        index: index,
      });
      setBatchName("");
      dispatch(getBatchStatusClear());
    } else {
      setProjectData({
        name: "",
        index: null,
      });
      setBatchName("");
      dispatch(getBatchStatusClear());
    }
  };

  const onChangeBatch = (_, newValue) => {
    if (newValue) {
      dispatch(getBatchStatus(projectData?.name, newValue));
      setBatchName(newValue);
      setStatusLoading(true);
    } else {
      setBatchName("");
      dispatch(getBatchStatusClear());
    }
  };

  return (
    <Card
      variant="outlined"
      className="weidget-count-card-box-batch-status"
      sx={{ height: "100%" }}
    >
      <CardContent>
        <Label text="Batch Status" fontSize="16px" fontWeight="600" />

        <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
          <Autocomplete
            size="small"
            options={
              projectAndBatches?.map((project) => project.drug_product) || []
            }
            value={projectData?.name || ""}
            onChange={handleChangeProjectName}
            renderInput={(params) => (
              <TextField {...params} label="Product Name" />
            )}
          />
        </FormControl>

        <FormControl variant="standard" sx={{ m: 1, minWidth: 200 }}>
          <Autocomplete
            size="small"
            options={
              projectData.index !== null
                ? projectAndBatches[projectData.index]?.batches_list || []
                : []
            }
            value={batchName || ""}
            onChange={onChangeBatch}
            renderInput={(params) => (
              <TextField {...params} label="Batch Name" />
            )}
          />
        </FormControl>

        <CustomizedSteppers
          currentStep={batchStatusAndName?.batchStatus}
          statusLoading={statusLoading}
        />
      </CardContent>
    </Card>
  );
};

export default BatchStatusCard;
